const resolveAssignedAgentIdFromCustomer = (customer) => (
  customer?.retailer_user_id
  ?? customer?.assigned_agent?.id
  ?? customer?.agent_customer?.retailer_user_id
  ?? customer?.retailer_user?.id
  ?? null
);

export default resolveAssignedAgentIdFromCustomer;
